import type { DeclaredNodePayload } from '@Application/Documents/TemplateFiles/Actions/documentTemplateFileDescribed';

/** Immutable View: `readonly` properties, frozen at the end of the constructor. */
class DocumentTemplateFilePreviewNodeView {
	readonly uuid: string;
	readonly path: string;
	readonly name: string;
	readonly isList: boolean;
	readonly order: number;

	constructor(payload: DeclaredNodePayload) {
		this.uuid = payload.uuid;
		this.path = payload.path;
		this.name = payload.name;
		this.isList = payload.isList;
		this.order = payload.order;

		Object.freeze(this);
	}
}

export default DocumentTemplateFilePreviewNodeView;
